module.exports = __webpack_public_path__ + "static/media/gg.d080b3f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gg.svg
// module id = 126
// module chunks = 0